
import './contact.scss';
import lokacija from '../assets/lokacija1.png';
import Header from './header.jsx';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const navigate = useNavigate();
  return (
    <div>
        <Header />
    <div className="contact-container">    
      <div className="map">
        <img src={lokacija} alt="Store Location" />
      </div>
      
        
    <div className="contact-details">
        <p>
          Cvrle DOO <br/> 
          Bajči Žilinskog 11, 
          21000 Novi Sad <br/>
          Kontakt:
          021/3101-301 <br/>
          065/2790-497 <br/>
          Email: cvrledoo@orion.com <br/>
          PIB: 105909610 <br/>
          MB: 20487526 <br/>        
        </p>      
      </div>        
     
    </div>
    <button onClick={() => navigate('/')} className="home-button">Nazad</button> 
    </div>
  );
};

export default Contact;
